var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var stdin_exports = {};
__export(stdin_exports, {
  unescapeString: () => unescapeString
});
module.exports = __toCommonJS(stdin_exports);
const escapeDict = { b: "\b", f: "\f", n: "\n", r: "\r", t: "	", v: "\v" };
function unescapeString(str) {
  return typeof str === "string" ? str.replace(/\\(u\d{4}|[^u])/g, (_, x) => {
    if (x[0] === "u")
      return String.fromCharCode(parseInt(x.slice(1), 16));
    return escapeDict[x] || x;
  }) : str;
}
